import { render, staticRenderFns } from "./Neighborhood.vue?vue&type=template&id=55b03df6&scoped=true&"
import script from "./Neighborhood.vue?vue&type=script&lang=js&"
export * from "./Neighborhood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b03df6",
  null
  
)

export default component.exports